import { css } from '@bts-web/utils-style-engine';
import { AssetCell } from '../../common/components/AssetCell/AssetCell';
import { CreateSwapOfferMutation$data } from '@bts-web/data-layer/server';
import { AcceptSwapScreenTranslations } from './getAcceptSwapTranslations';
import { getAssetDisplayValueFromSource } from '@bts-web/core-features/common';

export const SwappedAssetsSummaryBox = ({
  offerData,
  translations,
  locale,
  // currency,
}: {
  offerData: CreateSwapOfferMutation$data['createSwapOffer'];
  translations: AcceptSwapScreenTranslations;
  locale: string;
  currency: string;
}) => {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid',
        background: 'neutrals.card_fill_primary',
        borderColor: 'neutrals.stroke_secondary',
        borderRadius: '16px',
        px: 'small',

        '& > div:first-child': {
          borderBottom: '1px solid',
          borderColor: 'neutrals.stroke_secondary',
        },
      })}
    >
      <AssetCell
        dataTestId="swap-source-asset"
        logoUrl={offerData?.sourceAsset.logoUrl as string}
        name={offerData?.sourceAsset.name as string}
        nameDescription={translations.payWith}
        value={getAssetDisplayValueFromSource({
          sourceType: 'ASSET',
          sourceAmount: (
            offerData?.sourceAmount as {
              value: string;
              precision: number;
            }
          ).value,
          customSymbol: offerData?.sourceAsset.symbol as string,
          locale,
        })}
        // valueDescription={getAssetDisplayValueFromSource({ //TODO: nees WL support for fiat amount
        //   sourceType: 'FIAT',
        //   sourceAmount: (
        //     offerData?.sourceAsset.price as {
        //       value: string;
        //       precision: number;
        //     }
        //   ).value,
        //   currency: currency,
        //   locale,
        // })}
      />

      <AssetCell
        dataTestId="swap-target-asset"
        logoUrl={offerData?.targetAsset.logoUrl as string}
        name={offerData?.targetAsset.name as string}
        nameDescription={translations.get}
        value={getAssetDisplayValueFromSource({
          sourceType: 'ASSET',
          sourceAmount: (
            offerData?.targetAmount as {
              value: string;
              precision: number;
            }
          ).value,
          customSymbol: offerData?.targetAsset.symbol as string,
          locale,
        })}
      />
    </div>
  );
};
